class VaillantFilterGroups extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick, true);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick, true);
  }

  handleClick = (event) => {
    const toggle = event.target.closest('[data-vaillant-filter-toggle]');

    if (toggle && this.contains(toggle)) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.closest('.vaillant-filter__group')?.classList.toggle('is-open', !expanded);
      if (panel) panel.hidden = expanded;
      return;
    }

    const applyButton = event.target.closest('[data-vaillant-filter-apply]');
    if (!applyButton || !this.contains(applyButton)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const drawer = this.closest('vaillant-filter-drawer, menu-drawer');
    const summary = drawer?.querySelector(':scope > details > summary');

    if (drawer?.closeMenuDrawer) {
      drawer.closeMenuDrawer(event, summary);
    } else {
      summary?.click();
    }
  };
}

class VaillantFilterDrawer extends MenuDrawer {
  constructor() {
    super();
    this.portalRoot = null;
    this.facetsPlaceholder = null;
    this.onPortalClick = this.handlePortalClick.bind(this);
  }

  openMenuDrawer(summaryElement) {
    super.openMenuDrawer(summaryElement);
    this.portalToBody();
    this.bindPortalEvents();

    const panel = this.portalRoot?.querySelector('.mobile-facets__inner');
    if (panel) trapFocus(panel, summaryElement);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.unbindPortalEvents();
    this.unportalFromBody();

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('vaillant-filter-drawer-open');
    window.scrollLock?.unlock();
    removeTrapFocus(elementToFocus);
    elementToFocus?.setAttribute('aria-expanded', false);
  }

  onCloseButtonClick(event) {
    if (event.currentTarget.closest('[data-vaillant-filter-close]')) {
      event.preventDefault();
      event.stopPropagation();
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      return;
    }

    if (event.currentTarget.closest('[data-vaillant-filter-apply]')) return;

    super.onCloseButtonClick(event);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.mainDetailsToggle.hasAttribute('open')) return;
      if (this.portalRoot?.contains(document.activeElement)) return;
      if (this.mainDetailsToggle.contains(document.activeElement)) return;

      this.closeMenuDrawer(new Event('focusout'), this.mainDetailsToggle.querySelector('summary'));
    });
  }

  bindPortalEvents() {
    this.portalRoot?.addEventListener('click', this.onPortalClick, true);
  }

  unbindPortalEvents() {
    this.portalRoot?.removeEventListener('click', this.onPortalClick, true);
  }

  handlePortalClick(event) {
    if (!this.portalRoot) return;

    const inner = this.portalRoot.querySelector('.mobile-facets__inner');
    const isCloseButton = event.target.closest('[data-vaillant-filter-close]');
    const isOverlay = event.target.closest('[data-vaillant-filter-overlay]');

    if (isCloseButton || isOverlay) {
      event.preventDefault();
      event.stopPropagation();
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      return;
    }

    if (inner?.contains(event.target)) return;

    const facetsPanel = this.portalRoot.querySelector('.mobile-facets');
    if (facetsPanel?.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
    }
  }

  portalToBody() {
    const facetsPanel = this.querySelector('.mobile-facets');
    if (!facetsPanel || this.portalRoot) return;

    this.facetsPlaceholder = document.createComment('vaillant-filter-drawer-anchor');
    facetsPanel.parentNode.insertBefore(this.facetsPlaceholder, facetsPanel);

    this.portalRoot = document.createElement('div');
    this.portalRoot.className = 'vaillant-filter-drawer vaillant-filter-drawer--portaled';
    this.portalRoot.appendChild(facetsPanel);
    document.body.appendChild(this.portalRoot);
    document.body.classList.add('vaillant-filter-drawer-open');
  }

  unportalFromBody() {
    const facetsPanel = this.portalRoot?.querySelector('.mobile-facets');

    if (facetsPanel && this.facetsPlaceholder?.parentNode) {
      this.facetsPlaceholder.parentNode.insertBefore(facetsPanel, this.facetsPlaceholder);
    }

    this.facetsPlaceholder?.remove();
    this.portalRoot?.remove();
    this.portalRoot = null;
    this.facetsPlaceholder = null;
    document.body.classList.remove('vaillant-filter-drawer-open');
  }
}

if (!customElements.get('vaillant-filter-groups')) {
  customElements.define('vaillant-filter-groups', VaillantFilterGroups);
}

if (!customElements.get('vaillant-filter-drawer')) {
  customElements.define('vaillant-filter-drawer', VaillantFilterDrawer);
}
